import { render } from "./BestServicesKids.vue?vue&type=template&id=bb67cbfc"
import script from "./BestServicesKids.vue?vue&type=script&lang=js"
export * from "./BestServicesKids.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__